module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/invoice-update/invoice-job-info/invoice-job-info.scss
// module id = ./web/modern/components/invoices/invoice-update/invoice-job-info/invoice-job-info.scss
// module chunks = 0